module.exports = __webpack_public_path__ + "static/media/webCheckout.bee45cc8.jpg";